import { fetcher } from "helpers/fetcher";

import { TGetListSalesReq, TGetListSalesRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getListSales = async (payload: TGetListSalesReq) => {
  return await fetcher<TGetListSalesRes, TGetListSalesReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_LIST_SALES,
    {
      headers: {
        [API_HEADER.BU_ID]: payload.idBu,
      },
      data: payload.data,
    }
  );
};

export const queryGetListSales = async (payload: TGetListSalesReq) => {
  return await getListSales(payload);
};

queryGetListSales._key = (payload?: TGetListSalesReq) => [
  ENDPOINT.MANAGEMENT.GET_LIST_SALES.url,
  payload,
];
